import { Accordion, AccordionDetails, Grid, Typography } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import React, { useState } from 'react';
import { FormikProps } from 'formik';
import { PmiButton } from 'shell/components/shared/button';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import PmiTextField from 'shell/components/shared/text-field';
import { subscriberForm } from 'system/pages/subscriber/list/types';

interface Props {
  subscriberFormProps: FormikProps<subscriberForm>;
}

const SubscriberFilterForm = ({ subscriberFormProps }: Props): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(true);
  return (
    <>
      <Accordion
        expanded={open}
        onChange={() => {
          setOpen(!open);
        }}
      >
        <AccordionSummary
          aria-controls="panel-townhalls-content"
          id="panel-townhalls-header"
          classes={{
            root: 'pmi-flex-row-reverse',
          }}
          expandIcon={<ExpandMore />}
        >
          <Typography>Filtri</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <form onSubmit={subscriberFormProps.handleSubmit}>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} md={4}>
                <PmiTextField
                  aria-label="Codice"
                  label="Codice"
                  id="code"
                  name="code"
                  value={subscriberFormProps.values.code}
                  onChange={subscriberFormProps.handleChange}
                  helperText={subscriberFormProps.values.code}
                  error={
                    Boolean(subscriberFormProps.errors.code) && subscriberFormProps.touched.code
                  }
                  fullWidth
                  type="text"
                  variant="outlined"
                  inputProps={{
                    maxLength: '2',
                  }}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <PmiTextField
                  aria-label="Descrizione zona"
                  label="Descrizione"
                  id="description"
                  value={subscriberFormProps.values.description}
                  error={
                    Boolean(subscriberFormProps.errors.description) &&
                    subscriberFormProps.touched.description
                  }
                  helperText={subscriberFormProps.errors.description}
                  onChange={subscriberFormProps.handleChange}
                  name="description"
                  fullWidth
                  type="text"
                  variant="outlined"
                  inputProps={{
                    maxLength: '20',
                  }}
                />
              </Grid>
              <Grid item xs>
                <PmiButton variant="contained" color="secondary" type="submit">
                  Cerca
                </PmiButton>
              </Grid>
            </Grid>
          </form>
        </AccordionDetails>
      </Accordion>
    </>
  );
};

SubscriberFilterForm.displayName = 'Subscriber filter form component';
export default SubscriberFilterForm;
